/**
 * Button
 *
 * @author Dominique Rau [domi.github@gmail.com](mailto:domi.github@gmail.com)<br/>
 * @version 0.0.1
 */
import { default as MaterialButton } from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
export var Button = withStyles({
    root: {
        textTransform: 'none',
    },
})(MaterialButton);
